(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const tabsEls = document.querySelectorAll('.splide--category-tabs');
    tabsEls.forEach(function (tabsEl) {
      if (typeof Splide !== 'undefined') {
        new Splide(tabsEl, {
          type: 'slide',
          drag: 'free',
          gap: '0.5rem',
          autoWidth: true,
          arrows: false,
          pagination: false,
          snap: false,
        }).mount();
      }
    });

    const productSliders = document.querySelectorAll('.splide--category-products');
    productSliders.forEach(function (el) {
      if (typeof Splide !== 'undefined') {
        const splide = new Splide(el, {
          type: 'slide',
          drag: true,
          gap: '1rem',
          autoWidth: true,
          snap: false,
          arrows: false,
          pagination: false,
          breakpoints: {
            639: {
              gap: '0.5rem',
            },
          },
        });
        splide.mount();
        el.splideInstance = splide;
      }
    });

    const tabButtons = document.querySelectorAll('[data-tab-btn]');
    tabButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const targetTabId = btn.getAttribute('data-tab-target');
        setTimeout(() => {
          const activeSlider = document.querySelector(`.splide--category-products[data-tab-id="${targetTabId}"]`);
          if (activeSlider && activeSlider.splideInstance) {
            activeSlider.splideInstance.refresh();
          }
        }, 50);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const splideFeaturedList = document.querySelectorAll('.splide--featured-collection');
    splideFeaturedList.forEach(function (el) {
      if (typeof Splide !== 'undefined') {
        new Splide(el, {
          type: 'slide',
          drag: true,
          gap: '1rem',
          autoWidth: true,
          snap: false,
          arrows: false,
          pagination: false,
          breakpoints: {
            639: {
              gap: '0.5rem',
            },
          },
        }).mount();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const splideNav = document.querySelector('.splide--nav-collections');
    if (splideNav && typeof Splide !== 'undefined') {
      new Splide(splideNav, {
        type: 'slide',
        drag: true,
        gap: '1rem',
        autoWidth: true,
        wheel: true,
        snap: false,
        arrows: false,
        pagination: true,
      }).mount();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const initSlideshow = (el) => {
      if (typeof Splide !== 'undefined') {
        const isAutoplay = el.getAttribute('data-autoplay') === 'true';
        const interval = parseInt(el.getAttribute('data-interval')) || 5000;
        const speed = parseInt(el.getAttribute('data-speed')) || 800;

        new Splide(el, {
          type: 'fade',
          rewind: true,
          autoplay: isAutoplay,
          interval: interval,
          speed: speed,
          arrows: false,
          pagination: true,
          drag: true,
          keyboard: true,
        }).mount();
      }
    };

    const slideshows = document.querySelectorAll('.splide--slideshow');
    slideshows.forEach(initSlideshow);

    // Note: Shopify Theme Editor support
    document.addEventListener('shopify:section:load', function (event) {
      const el = event.target.querySelector('.splide--slideshow');
      if (el) {
        initSlideshow(el);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const splideTestimonials = document.querySelectorAll('.splide--testimonials');
    splideTestimonials.forEach(function (el) {
      if (typeof Splide !== 'undefined') {
        new Splide(el, {
          type: 'slide',
          drag: true,
          gap: '1rem',
          autoWidth: true,
          snap: false,
          arrows: false,
          pagination: false,
        }).mount();
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
